import WideoDef, { ComponentDef, SceneDef, WideoObjectDef } from '../../common/core/model/WideoDef';

export const isProjectDynamic = (wideoDef: WideoDef | null | undefined): boolean => {
  if (!wideoDef) {
    return false;
  }

  if (hasDynamicSignalsInObjects(wideoDef.audios, 'Nivel Global (Audios)')) {
    return true;
  }

  const scenes: SceneDef[] = wideoDef.scenes || [];
  for (let i = 0; i < scenes.length; i++) {
    const scene = scenes[i];
    if (!scene) continue;

    const sceneContext = `Escena [${i}] (ID: ${scene.id?.substring(0, 8)}...)`;

    if (hasDynamicSignalsInComponents(scene.components, sceneContext)) {
      return true;
    }

    if (hasDynamicSignalsInObjects(scene.objects, sceneContext)) {
      return true;
    }
  }

  return false;
};

const hasDynamicSignalsInObjects = (objects: WideoObjectDef[] | undefined, context: string): boolean => {
  if (!objects || objects.length === 0) return false;

  const stack: WideoObjectDef[] = [...objects];

  while (stack.length > 0) {
    const obj = stack.pop();
    if (!obj) continue;

    const currentContext = `${context} -> Objeto: ${obj.class} (${obj.id?.substring(0, 5)})`;

    if (isDynamicObjectClass(obj.class)) {
      return true;
    }

    if (hasDynamicSignalsInComponents(obj.components, currentContext)) {
      return true;
    }

    if (obj.objects && obj.objects.length > 0) {
      for (const child of obj.objects) {
        if (child) stack.push(child);
      }
    }
  }

  return false;
};

const hasDynamicSignalsInComponents = (components: ComponentDef[] | undefined, context: string): boolean => {
  if (!components || components.length === 0) return false;

  for (const comp of components) {
    if (!comp) continue;

    const className = normalizeClass(comp.class);

    if (className === 'video' || className === 'audio' || className === 'transition') {
      return true;
    }

    if (className === 'animation') {
      const animComp = comp as any;
      const keyFrames = animComp.animation?.keyFrames;
      if (Array.isArray(keyFrames) && keyFrames.length > 0) {
        return true;
      }
    }

    if (className === 'image') {
      const imgComp = comp as any;
      const isAnimated = imgComp.animated === true;
      const isGifUrl = typeof imgComp.src === 'string' && imgComp.src.toLowerCase().includes('.gif');

      if (isAnimated || isGifUrl) {
        return true;
      }
    }
  }

  return false;
};

const isDynamicObjectClass = (objectClass: string | undefined): boolean => {
  const normalized = normalizeClass(objectClass);
  return (
    normalized === 'videoobject' ||
    normalized === 'audioobject' ||
    normalized === 'animatedgroupobject'
  );
};

const normalizeClass = (className: string | undefined): string => {
  return (className || '').toLowerCase().trim();
};
